import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface AssessmentScoresByGenreHistoryResponse {
  assessment_scores_history: AssessmentScoresByGenreHistoryData[]
}

export type AssessmentScoresByGenreHistoryData = {
  student_id: number
  fiction?: number
  nonfiction?: number
  last_fiction_lexile?: number
  last_nonfiction_lexile?: number
  quizzes_taken?: number
}

export async function assessmentScoresByGenreHistory(
  this: StudentEventsService,
  product: LegacyProductRex,
  scope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<AssessmentScoresByGenreHistoryData[]>> {
  if (isEmpty(scope.ids)) return null

  const url = this.buildUrl('assessment_scores_history', product, scope)
  const query = this.buildQuery(scope, period)

  const data = await this.fetchData<AssessmentScoresByGenreHistoryResponse>(url, query)
  if (!data) return null
  if (data.assessment_scores_history.length === 0) return null

  return data.assessment_scores_history
}
